import setSiteMeta from '../base-saving-actions/set-site-meta';

const createCustomColorPalettes = (palettes) =>
  palettes.map((palette) =>
    setSiteMeta(['customization', 'customColorPalettes', palette.id], palette)
  );

export default createCustomColorPalettes;
